export enum NotificationTheme {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ALERT = 'alert',
  SUSTAINABILITY = 'sustainability',
  CAMPAIGN = 'campaign',
  TRANSPARENT = 'transparent',
  DISRUPTION = 'disruption',
  ERROR = 'error',
  PROMOTION = 'promotion',
}

export enum NotificationLayout {
  BLOCK = 'block',
  EDGE_TO_EDGE = 'edge_to_edge', // @Deprecated
  INLINE = 'inline',
  OVERLAY = 'overlay',
}

export enum NotificationScale {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum NotificationButtonStyle {
  BUTTON = 'button',
  LINK = 'link',
}
